import type { WordCollection } from "../collection.types";

export const autumnEquinoxCollection: WordCollection = {
  id: "autumn-equinox",
  title: "Autumn Equinox (Mabon)",
  icon: "leaf-maple",
  isWordlistViewable: true,
  startDate: new Date(new Date().getFullYear(), 8, 20), // September 20th
  endDate: new Date(new Date().getFullYear(), 8, 25), // September 25th
  words: [
    "advice",
    "ash",
    "balance",
    "basket",
    "bread",
    "bronze",
    "cedar",
    "ceremony",
    "change",
    "circle",
    "clarity",
    "copper",
    "corn",
    "counsel",
    "gold",
    "gratitude",
    "harmony",
    "maple",
    "oak",
    "pine",
    "prayer",
    "root",
    "rust",
    "seed",
    "soil",
    "store",
    "tree",
    "tribute",
    "wheat",
    "wheel",
    "wine",
    "worship",
  ],
};
